import { injectStyle } from '__style_helper__'
injectStyle(".KS0k7q_badge{background-position:50%;background-repeat:no-repeat;background-size:cover}")
export default {"badge":"KS0k7q_badge",}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIiJdLCJtYXBwaW5ncyI6IkEifQ==